import {
  DataLine,
  Setting,
  ChatLineRound,
  EditPen,
  // Cpu,  // 模型配置暂时用不到，保留以便后续恢复
  PriceTag,
  Connection
} from '@element-plus/icons-vue'

/**
 * 管理端菜单配置
 * 静态菜单，后续添加新菜单只需在此配置并创建对应的路由和页面
 */
export default [
  {
    key: 'dashboard',
    path: '/dashboard',
    icon: DataLine,
    title: '仪表盘'
  },
  {
    key: 'systemConfig',
    path: '/system/config',
    icon: Setting,
    title: '系统配置'
  },
  {
    key: 'conversations',
    path: '/conversations',
    icon: ChatLineRound,
    title: '问答记录'
  },
  {
    key: 'feedbackRecords',
    path: '/feedback-records',
    icon: ChatLineRound,
    title: '反馈记录'
  },
  {
    key: 'modelAnnotation',
    path: '/model/annotation',
    icon: PriceTag,
    title: '模型标注'
  },
  {
    key: 'modelTraining',
    path: '/model/training',
    icon: Connection,
    title: '模型训练'
  },
  // {
  //   key: 'knowledgeBase',
  //   path: '/knowledge/base',
  //   icon: FolderOpened,
  //   title: '知识库管理'
  // },
  // {
  //   key: 'modelConfig',
  //   path: '/model/config',
  //   icon: Cpu,
  //   title: '模型配置'
  // },
  {
    key: 'systemPrompt',
    path: '/system/prompt',
    icon: EditPen,
    title: '系统提示词设置'
  }
  // {
  //   key: 'userManagement',
  //   path: '/user/management',
  //   icon: User,
  //   title: '用户管理'
  // }
]

